import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import { useAuthStore } from '../store/auth'
import { safeReturnPath } from '../auth/browser-session.mjs'

const routes = [
  { path: '/account-management', component: () => import('../views/AccountManagementView.vue') },
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true } // 需要登录访问
  },
  {
    path: '/dashboard/grid',
    name: 'DashboardGrid',
    component: () => import('../views/GridDashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/devices',
    name: 'DeviceManagement',
    component: () => import('../views/DeviceManagementView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/monitor/:sid',
    name: 'Monitor',
    component: () => import('../views/MonitorView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/alerts',
    name: 'EnvelopePending',
    component: () => import('../views/EnvelopePendingView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/alerts/history',
    name: 'EnvelopeHistory',
    component: () => import('../views/EnvelopeHistoryView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/envelope-alerts',
    name: 'EnvelopeAlertSettings',
    component: () => import('../views/EnvelopeAlertSettingsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false } // 登录页不需要认证
  }
  ,{
    path: '/login-complete',
    name: 'LoginComplete',
    component: () => import('../views/LoginCompleteView.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局前置路由守卫
let navigationGeneration = 0
router.beforeEach(async (to, from, next) => {
  const generation = ++navigationGeneration
  const authStore = useAuthStore()
  
  // 总是先尝试初始化认证状态（读取 Cookie）
  if (to.path === '/login-complete' || to.path === '/login') return next()
  try {
    const user = await authStore.fetchUserInfo()
    if (generation !== navigationGeneration || !user) return next(false)
  } catch (error) {
    if (generation !== navigationGeneration || error.authStale) return next(false)
    if (error.response?.status !== 401) return next({ path: '/login', query: { return_to: to.fullPath, retry: '1' } })
  }
  
  // 检查是否需要认证
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // 未登录，重定向到 SSO 登录页面
    return next({ path: '/login', query: { return_to: to.fullPath } })
  }
  
  // 如果已登录且访问的是登录页，重定向回首页
  if (to.path === '/login' && authStore.isAuthenticated) {
    next(safeReturnPath(to.query.return_to))
    return
  }

  if (to.meta.requiresAdmin) {
    const ensure = authStore.userInfo ? Promise.resolve(authStore.userInfo) : authStore.fetchUserInfo()
    ensure
      .then(user => {
        const role = user?.role
        if (role === 'admin' || role === 'superuser') {
          next()
        } else {
          next('/')
        }
      })
      .catch(() => {
        next('/')
      })
    return
  }
  
  next()
})

export default router
